import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuestionariosComponent } from './questionarios.component';
import { AddNewQuestionarioComponent } from './components/add-new-questionario/add-new-questionario.component';
import { PermissionsGuard } from 'src/app/shared/guards/permissions.guard';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';

const routes: Routes = [
  {
    path: '',
    component: QuestionariosComponent
  },
  {
    path: 'personalizados',
    title: 'Questionários Personalizados',
    component: AddNewQuestionarioComponent,
    canActivate: [PermissionsGuard],
    data: [
      {
        role: [ERoleAdminString.Admin, ERoleAdminString.QuestionnaireAdmin],
        claim: {
          nome: 'questionarios',
          valor: 'questionnaire.list'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuestionariosRoutingModule {}
